import { useEffect, useState } from "react";
import { Icon } from "./Icons";

export default function ComposeModal({ open, onClose, onSend }) {
  const [form, setForm] = useState({ to: "", subject: "", body: "" });
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    const close = (event) => event.key === "Escape" && !sending && onClose();
    window.addEventListener("keydown", close);
    return () => window.removeEventListener("keydown", close);
  }, [open, onClose, sending]);

  if (!open) return null;
  async function submit(event) {
    event.preventDefault();
    setSending(true);
    try {
      await onSend(form);
      setForm({ to: "", subject: "", body: "" });
      onClose();
    } finally {
      setSending(false);
    }
  }

  return (
    <div className="modalBackdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && !sending && onClose()}>
      <form className="composeModal" onSubmit={submit}>
        <header><div><p className="eyebrow">NEW MESSAGE</p><h2>Новое письмо</h2></div><button type="button" className="iconButton" onClick={onClose}><Icon name="close" /></button></header>
        <label>Кому<input type="email" required autoFocus value={form.to} onChange={(e) => setForm({ ...form, to: e.target.value })} placeholder="name@example.com" /></label>
        <label>Тема<input required maxLength={200} value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} placeholder="О чём это письмо?" /></label>
        <label>Сообщение<textarea required maxLength={100000} rows={10} value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} placeholder="Введите текст..." /></label>
        <footer><button type="button" className="textButton" onClick={onClose}>Отмена</button><button className="primaryButton" disabled={sending}>{sending ? <span className="spinner" /> : <Icon name="send" />}Отправить</button></footer>
      </form>
    </div>
  );
}
